import { fetchWrapper } from "../Helpers";

export const uploadService = {
  getFiles,
  upload,
  uploadInfluencerChatAttachment,
};

function upload(file, onUploadProgress, isAsset = false, isGallery = false) {
  let formData = new FormData();
  formData.append('file_name', file);
  formData.append('visibility', 'public');
  formData.append('is_thumbnail', 1);
  return fetchWrapper.postFile(
    isAsset ? '/upload/asset' : isGallery ? '/upload/media' : '/upload/asset',
    formData,
    onUploadProgress
  );
}

function getFiles() {
  return fetchWrapper.get("/files");
}

function uploadInfluencerChatAttachment(
  file,
  onUploadProgress,
   isAsset = false, isGallery = false
) {
   let formData = new FormData();
  formData.append("file_name", file);
  formData.append("visibility", "public");
  formData.append("is_thumbnail", 1);
  return fetchWrapper.postFile(
    isAsset ? "/upload/chat" : isGallery ? "/upload/chat" : "/upload/chat",
    formData,
    onUploadProgress
  );
}
